import { getSessionStorageItemJson, setSessionStorageItemJson, } from '@vfde-sails/storage';
import { requestJson } from '@vfde-sails/utils';
import {
    call,
    put,
    select,
    takeLatest,
} from 'redux-saga/effects';
import {
    SESSION_STORAGE_GLASFASER_VFP_FLOW,
} from '../../constant';
import {
    getAddressNotFound,
    getAddressSuccess,
    handleInvalidApiCall,
    handleValidApiCall,
    trackAddressFound,
    trackAddressNotFound,
    trackInitialPageView,
} from './action';
import {
    GET_ADDRESS,
    GLASFASER_API_URL,
    INIT_ADDRESS_FORM,
    INIT_APP,
} from './constant';
import { getDecodedResponseData, getQueryString } from './helpers/sagaHelper';
import { selectFormData } from './selector';

/**
 * getApiData
 */
export function* getGlasfaserApiData () {
    const formData = yield select(selectFormData());
    const queryString = getQueryString(formData);

    try {
        const apiURL = GLASFASER_API_URL + queryString;
        const response = yield call(requestJson, apiURL);
        const responseData = response.body.data;

        yield put(handleValidApiCall(responseData));

        if (!responseData) {
            yield call(resetSessionStorage);
            yield put(getAddressNotFound());
            yield put(trackAddressNotFound());
        } else {
            const decodedResponseData = getDecodedResponseData(responseData);

            yield call(setSessionStorageResult, decodedResponseData);
            yield put(getAddressSuccess());
            yield put(trackAddressFound(responseData.ADRESSART, responseData.TECHNOLOGIE));
        }

    } catch (e) {
        yield put(handleInvalidApiCall());
    }
}

/**
 * initTracking
 */
export function* initTracking () {
    yield put(trackInitialPageView());
}

/**
 * saves result of last adress check in session storage
 */
export function* setSessionStorageResult (responseData) {
    yield call(setSessionStorageItemJson, SESSION_STORAGE_GLASFASER_VFP_FLOW, responseData);
}

/**
 * saves result of last adress check in session storage
 */
export function* getSessionStorageResult () {
    const sessionStorageState = yield getSessionStorageItemJson(SESSION_STORAGE_GLASFASER_VFP_FLOW);
    const keyLen = sessionStorageState ? Object.keys(sessionStorageState).length : 0;

    if (0 < keyLen) {
        yield put(handleValidApiCall(sessionStorageState));
        yield put(getAddressSuccess());
    }
}

/**
 * saves result of last adress check in session storage
 */
export function* resetSessionStorage () {
    sessionStorage.removeItem(SESSION_STORAGE_GLASFASER_VFP_FLOW);
}

/**
 * export form data saga
 */
export default function* glasfaserVfpSaga () {
    yield takeLatest(GET_ADDRESS, getGlasfaserApiData);
    yield takeLatest(INIT_APP, getSessionStorageResult);
    yield takeLatest(INIT_ADDRESS_FORM, initTracking);
}
